import {
  Input as ChakraInput,
  InputGroupProps,
  InputProps as ChakraInputProps,
} from '@chakra-ui/react';

import { InputGroup } from '../../lib/chakraUi/components';
import {
  FormFieldUncontrolledComponent,
  FormFieldUncontrolledComponentProps,
} from '../../types/fields';

export type InputProps = ChakraInputProps &
  Pick<InputGroupProps, 'startElement' | 'endElement'>;

export const Input: FormFieldUncontrolledComponent<InputProps> = ({
  _ref,
  startElement,
  endElement,
  ...props
}: FormFieldUncontrolledComponentProps<InputProps>) => (
  <InputGroup endElement={endElement} startElement={startElement}>
    <ChakraInput ref={_ref} id={props.name} {...props} />
  </InputGroup>
);

Input.controlled = false;
Input.displayName = 'Input';
